import { useTranslation } from "react-i18next";
import { SelectField, } from "melco-shared-logic";
import { usePartners } from "../../hooks/settings/usePartners";

export const SelectPartnerField: React.FC = () => {
    const { t } = useTranslation();

    const { data: partners, isLoading } = usePartners();

    const filteredPartners = (partners ?? [])

    const unsortedOptions = filteredPartners.map(({ code, name }) => {
        return {
            label: name ?? code ?? "",
            value: code ?? "",
        };
    });


    return (
        <SelectField
            name="partner"
            label={t("eodsettings.actions.add.form.label.type")}
            options={unsortedOptions}
            optionFilterProp="label"
            loading={isLoading}
        />
    );
};
